import { Routes } from '@angular/router';

export const legacyRoutes: Routes = [
    {
        path: 'my/dashboard/transactions/v3/:id/:section/:section',
        redirectTo: 'my/dashboard/transactions/v3/:id/:section',
        pathMatch: 'full'
    },
    {
        path: 't/transactions/v3/:id/:key/:mid/:section/:section',
        redirectTo: 't/transactions/v3/:id/:key/:mid/:section',
        pathMatch: 'full'
    }
];
